/**
 * TypingIndicator - three dots pulsing in sequence.
 * Default renders the classic chat bubble; `bubble={false}` gives just the
 * dot row so loading states can wrap it in their own container.
 */

interface TypingIndicatorProps {
  className?: string;
  /** Color class for the dots. */
  dotClassName?: string;
  /** Wrap the dots in the glass chat bubble (conversation view). */
  bubble?: boolean;
}

export default function TypingIndicator({
  className = '',
  dotClassName = 'bg-text-muted',
  bubble = true,
}: TypingIndicatorProps) {
  const dots = (
    <span className={`flex items-center gap-1 ${bubble ? '' : className}`}>
      {[0, 150, 300].map((delay) => (
        <span
          key={delay}
          className={`w-2 h-2 rounded-full animate-typing-dot ${dotClassName}`}
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </span>
  );

  if (!bubble) return dots;

  return (
    <div className={`flex items-center gap-1 px-4 py-3 ${className}`}>
      <div className="flex items-center gap-1 px-3 py-2 rounded-2xl rounded-bl-md glass">
        {dots}
      </div>
    </div>
  );
}
